import React from 'react';
import Icon from '@/components/ui/AppIcon';
import type { Lesson } from '@/lib/mockData';

interface Props { lesson: Lesson; }

export default function LessonOverviewTab({ lesson }: Props) {
  return (
    <div className="space-y-8">
      {/* Essential Question */}
      <div className="bg-primary-50 border border-primary-100 rounded-2xl p-6">
        <div className="flex items-center gap-2 mb-3">
          <Icon name="QuestionMarkCircleIcon" size={18} className="text-primary-600" />
          <h3 className="font-semibold text-primary-800 text-sm uppercase tracking-wider">
            Essential Question
          </h3>
        </div>
        <p className="font-display text-xl font-semibold text-primary-900 leading-snug">
          "{lesson.essentialQuestion}"
        </p>
      </div>

      {/* Learning Objectives */}
      <div>
        <h3 className="font-semibold text-stone-800 text-base mb-4 flex items-center gap-2">
          <Icon name="CheckCircleIcon" size={18} className="text-accent-600" />
          Learning Objectives
        </h3>
        <ul className="space-y-3">
          {lesson.objectives.map((obj, i) => (
            <li key={`obj-${i}`} className="flex items-start gap-3 text-sm text-stone-700">
              <span className="mt-0.5 w-6 h-6 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center text-xs font-bold flex-shrink-0">
                {i + 1}
              </span>
              {obj}
            </li>
          ))}
        </ul>
      </div>

      {/* Standards Alignment */}
      <div>
        <h3 className="font-semibold text-stone-800 text-base mb-4 flex items-center gap-2">
          <Icon name="DocumentCheckIcon" size={18} className="text-primary-600" />
          Standards Alignment
        </h3>
        <div className="flex flex-wrap gap-2">
          {lesson.standards.map((std) => (
            <span
              key={`std-${std}`}
              className="px-3 py-1.5 bg-stone-100 text-stone-700 rounded-lg text-xs font-medium border border-stone-200"
            >
              {std}
            </span>
          ))}
        </div>
      </div>

      {/* Materials */}
      <div>
        <h3 className="font-semibold text-stone-800 text-base mb-4 flex items-center gap-2">
          <Icon name="ClipboardDocumentListIcon" size={18} className="text-terracotta-500" />
          Materials Needed
        </h3>
        <ul className="space-y-2">
          {lesson.materials.map((mat) => (
            <li key={`mat-${mat}`} className="flex items-center gap-2.5 text-sm text-stone-700">
              <Icon name="CheckIcon" size={14} className="text-accent-500 flex-shrink-0" />
              {mat}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}